// 模板图片
import template1 from './jp-light.jpg';
import template2 from './zh-light.jpg';
import template3 from './noodle-light.jpg';
import template4 from './jp-dark.jpg';
import template5 from './noodle-dark.jpg';
import template6 from './hot-dark.jpg';
import template7 from './fire-dark.jpg';
import template8 from './cn-light.jpg';

const QOP_TEMPLATE = {
    template1,
    template2,
    template3,
    template4,
    template5,
    template6,
    template7,
    template8,
}
export default QOP_TEMPLATE